import { render, staticRenderFns } from "./NewUpdates.vue?vue&type=template&id=30181439"
import script from "./NewUpdates.vue?vue&type=script&lang=js"
export * from "./NewUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports